/**
 * ⚙️ BELTS
 *
 * Belt equipment items (10 total)
 * Level requirements: 10-80 (increments of ~10)
 * Stat requirements: STR for heavy belts, balanced for utility belts
 *
 * Level Distribution:
 * - Common (2): Lv 10, 15
 * - Uncommon (2): Lv 25, 30
 * - Rare (2): Lv 40, 45
 * - Epic (2): Lv 55, 60
 * - Legendary (2): Lv 75, 85
 */

export const BELTS = {
  // ============================================================
  // COMMON BELTS (2) - Lv 10, 15
  // ============================================================
  ropeBelt: {
    id: 'ropeBelt',
    name: 'Rope Belt',
    icon: '🪢',
    slot: 'belt',
    rarity: 'common',
    levelReq: 10,
    requirements: {},
    description: 'A simple rope tied around the waist.',
    stats: {
      health: 5,
      defense: 1,
    },
  },
  leatherBelt: {
    id: 'leatherBelt',
    name: 'Leather Belt',
    icon: '⚙️',
    slot: 'belt',
    rarity: 'common',
    levelReq: 15,
    requirements: { STR: 12 },
    description: 'A sturdy leather belt with a brass buckle.',
    stats: {
      health: 8,
      defense: 1,
    },
  },

  // ============================================================
  // UNCOMMON BELTS (2) - Lv 25, 30
  // ============================================================
  studdedBelt: {
    id: 'studdedBelt',
    name: 'Studded Belt',
    icon: '⚙️',
    slot: 'belt',
    rarity: 'uncommon',
    levelReq: 25,
    requirements: { STR: 40 },
    description: 'A reinforced belt with metal studs.',
    stats: {
      health: 15,
      defense: 2,
    },
  },
  chainBelt: {
    id: 'chainBelt',
    name: 'Chain Belt',
    icon: '⛓️',
    slot: 'belt',
    rarity: 'uncommon',
    levelReq: 30,
    requirements: { STR: 48 },
    description: 'A belt made of interlocking chains.',
    stats: {
      health: 12,
      defense: 3,
    },
  },

  // ============================================================
  // RARE BELTS (2) - Lv 40, 45
  // ============================================================
  runicBelt: {
    id: 'runicBelt',
    name: 'Runic Belt',
    icon: '📿',
    slot: 'belt',
    rarity: 'rare',
    levelReq: 40,
    requirements: { STR: 50, INT: 40 },
    description: 'A belt inscribed with powerful runes.',
    stats: {
      health: 25,
      defense: 5,
    },
  },
  dragonBelt: {
    id: 'dragonBelt',
    name: 'Dragon Belt',
    icon: '🐲',
    slot: 'belt',
    rarity: 'rare',
    levelReq: 45,
    requirements: { STR: 85 },
    description: 'A belt made from dragon hide.',
    stats: {
      health: 30,
      defense: 4,
    },
  },

  // ============================================================
  // EPIC BELTS (2) - Lv 55, 60
  // ============================================================
  titanBelt: {
    id: 'titanBelt',
    name: 'Titan Belt',
    icon: '⚜️',
    slot: 'belt',
    rarity: 'epic',
    levelReq: 55,
    requirements: { STR: 115 },
    description: 'A massive belt forged by titan smiths.',
    stats: {
      health: 55,
      defense: 8,
    },
  },
  voidSash: {
    id: 'voidSash',
    name: 'Void Sash',
    icon: '🌑',
    slot: 'belt',
    rarity: 'epic',
    levelReq: 60,
    requirements: { STR: 80, INT: 60 },
    description: 'A sash woven from threads of the void.',
    stats: {
      health: 65,
      defense: 6,
      speed: 1,
    },
  },

  // ============================================================
  // LEGENDARY BELTS (2) - Lv 75, 85
  // ============================================================
  eternityGirdle: {
    id: 'eternityGirdle',
    name: 'Eternity Girdle',
    icon: '✨',
    slot: 'belt',
    rarity: 'legendary',
    levelReq: 75,
    requirements: { STR: 150 },
    description: 'A belt that holds the power of eternity.',
    stats: {
      health: 100,
      defense: 12,
    },
  },
  cosmicCord: {
    id: 'cosmicCord',
    name: 'Cosmic Cord',
    icon: '🌌',
    slot: 'belt',
    rarity: 'legendary',
    levelReq: 85,
    requirements: { STR: 120, LUK: 60 },
    description: 'A cord that binds fate itself.',
    stats: {
      health: 85,
      defense: 10,
      critChance: 0.05,
    },
  },
};
